document.addEventListener("DOMContentLoaded", function() {
    if (document.getElementById("squiggly-line")) {
        document.getElementById("squiggly-line").classList.remove("hidden");

        const paths = document.querySelectorAll("#squiggly-line path");
        paths.forEach(path => {
            gsap.fromTo(path, {drawSVG: "0%"}, {duration: 2, drawSVG: "100%"});
        });
    }
});
